var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99997 0C4.07997 0 0.0899658 3.729 0.0899658 8.332C0.0899658 10.948 1.38097 13.284 3.40097 14.811V18L6.44197 16.313C7.25297 16.541 8.10997 16.663 9.00097 16.663C13.921 16.663 17.911 12.933 17.911 8.332C17.91 3.729 13.92 0 8.99997 0ZM9.93797 11.172L7.63297 8.778L3.19497 11.232L8.05997 6.069L10.365 8.464L14.804 6.009L9.93797 11.172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.0463548c8dcef1b9bdf401fe6e87cfa3.svg";
export { ForwardRef as ReactComponent };